import Flex from '@Components/Bases/Flex';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material';
import ModalRiskRelatedCheckboxList from './ModalRiskRelatedCheckboxList';
import { FormProvider, useForm } from 'react-hook-form';
import { IRelateMasterDataFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';
import ConfirmUpdateRelateRisk from './ConfirmUpdateRelateRisk';

type ModalAddRiskRelatedProps = {
  open: boolean;
  close: () => void;
  onUpdateRisks: (selectedRisks: IRelateMasterDataFormValues[]) => void;
  riskSelected: IRelateMasterDataFormValues[];
};

const mapRelateRisksFormValues = (
  riskSelected: IRelateMasterDataFormValues[]
) => {
  let riskFormValues = {};
  riskSelected.map((risk) => {
    riskFormValues = {
      ...riskFormValues,
      [`riskId${risk.infoCategoryMasterDataId}`]: { ...risk, checked: true },
    };
    return null;
  });

  return riskFormValues;
};

const ModalAddRiskRelated = (props: ModalAddRiskRelatedProps) => {
  const { open, close, riskSelected, onUpdateRisks } = props;
  const initialValues = mapRelateRisksFormValues(riskSelected);

  const formContext = useForm<
    Record<string, IRelateMasterDataFormValues & { checked?: boolean }>
  >({
    defaultValues: initialValues,
    mode: 'onChange',
  });

  return (
    <FormProvider {...formContext}>
      <form noValidate>
        <Dialog
          open={open}
          onClose={close}
          PaperProps={{
            style: {
              display: 'flex',
              width: '550px',
              flexDirection: 'column',
              height: '100vh',
              padding: '4px',
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: 800, fontSize: 14 }}>
            หัวข้อความเสี่ยงที่เกี่ยวข้อง
          </DialogTitle>
          <DialogContent>
            <ModalRiskRelatedCheckboxList />
          </DialogContent>
          <Divider />
          <DialogActions>
            <Flex gap={2} p={2} justifyContent="right">
              <Button variant="contained" color="inherit" onClick={close}>
                ยกเลิก
              </Button>
              <ConfirmUpdateRelateRisk
                onUpdateRisks={onUpdateRisks}
                close={close}
              />
            </Flex>
          </DialogActions>
        </Dialog>
      </form>
    </FormProvider>
  );
};

export default ModalAddRiskRelated;
